import { useQuery } from '@tanstack/react-query';
import { NotificationPreferences } from '@speles7172/message-console';
import '@speles7172/message-console/styles.css';
import { fetchPreferenceEvents, messageTransport } from '../../api/notifications';

/**
 * What a person wants to hear about, and where — the screen every email footer
 * points to ("manage your email preferences in your profile settings").
 *
 * The toggles are the package's `<NotificationPreferences>`, whole, for the
 * same reason `NotificationsPage` renders its console whole. The rows come from
 * `GET /notifications/events`, the events this application actually raises, so
 * nobody is offered a switch for something that never fires.
 */
export function NotificationSettings({ userId }: { userId: string }) {
  const {
    data: events,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['notifications', 'events'],
    queryFn: fetchPreferenceEvents,
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div className="bg-white rounded-lg shadow p-6">
      {isLoading ? (
        <div className="space-y-2" data-testid="notification-settings-loading">
          <div className="h-8 bg-gray-100 rounded animate-pulse" />
          <div className="h-8 bg-gray-100 rounded animate-pulse" />
        </div>
      ) : isError ? (
        <div className="text-sm text-red-700 bg-red-50 rounded px-3 py-2">
          Your notification settings could not be loaded.{' '}
          <button type="button" className="underline" onClick={() => void refetch()}>
            Try again
          </button>
        </div>
      ) : (
        <div className="peles-controls">
          <NotificationPreferences
            transport={messageTransport}
            recipientId={userId}
            events={events ?? []}
            title="Notifications"
          />
        </div>
      )}
    </div>
  );
}
